import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-page-links',
    standalone: false,
    template: `
    @if (totalPages > 1) {
      <div class="custom-page-links">
        <button mat-button (click)="goToPage(0)" [disabled]="pageIndex === 0">pierwsza</button>
        @if (startPage > 1) {
          <span>...</span>
        }
        @for (page of pageRange; track page) {
          <button
            mat-button
            (click)="goToPage(page)"
            [disabled]="page === pageIndex"
            style="min-width: 36px; margin: 0 2px;"
            >
            {{ page + 1 }}
          </button>
        }
        @if (endPage < totalPages - 2) {
          <span>...</span>
        }
        <button mat-button (click)="goToPage(totalPages - 1)" [disabled]="pageIndex === totalPages - 1">ostatnia</button>
      </div>
    }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./page-links.component.scss']
})
export class PageLinksComponent {
    @Input() totalPages!: number;
    @Input() pageIndex!: number;
    @Output() pageChange = new EventEmitter<number>();

    get startPage(): number {
        return Math.max(0, this.pageIndex - 2);
    }

    get endPage(): number {
        return Math.min(this.totalPages - 1, this.pageIndex + 2);
    }

    get pageRange(): number[] {
        const range = [];
        for (let i = this.startPage; i <= this.endPage; i++) {
            range.push(i);
        }
        return range;
    }

    goToPage(page: number): void {
        this.pageChange.emit(page);
    }
}
